import { render, staticRenderFns } from "./WorkSheetPage.vue?vue&type=template&id=73812cb4&scoped=true&"
import script from "./WorkSheetPage.vue?vue&type=script&lang=js&"
export * from "./WorkSheetPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkSheetPage.vue?vue&type=style&index=0&id=73812cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73812cb4",
  null
  
)

export default component.exports